import { z } from "zod";

/**
 * Shared search-param schema for the 7 main pages.
 * Values are intentionally loose (no enums/bounds) so an odd URL value is
 * visible to the component rather than silently swapped for a default.
 */
export const dashboardSearchSchema = z.object({
  range: z.string().optional(),
  office: z.string().optional(),
  compare: z.boolean().optional(),
});

/** All fields optional so plain <Link to="/"> stays valid. */
export type DashboardSearch = {
  range?: string | undefined;
  office?: string | undefined;
  compare?: boolean | undefined;
};

export const TIME_RANGES = [
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "1y", label: "Last 1 year" },
] as const;

export function validateDashboardSearch(search: Record<string, unknown>): DashboardSearch {
  const parsed = dashboardSearchSchema.safeParse(search);
  return parsed.success ? parsed.data : {};
}

/** Exceptions and Overrides adds a page-level PG/Corp segment filter. */
export const exceptionsSearchSchema = dashboardSearchSchema.extend({
  segment: z.enum(["all", "PG", "Corp"]).optional(),
});

export type ExceptionsSearch = DashboardSearch & {
  segment?: "all" | "PG" | "Corp" | undefined;
};

export function validateExceptionsSearch(search: Record<string, unknown>): ExceptionsSearch {
  const parsed = exceptionsSearchSchema.safeParse(search);
  return parsed.success ? parsed.data : {};
}
